window._setters = {
    _init: function(){
        this.body_margin();
        this.imgasbg._init();
        this.history._init();
    },
    body_margin: function(){
        var $element = document.querySelectorAll('[data-body-margin-top]');
        
        if($element[0]){
            var marginTop = $element[0].offsetHeight;
            document.body.style.marginTop = marginTop+'px';
        }
    },
    history: {
        _init: function(){
            window.addEventListener('load', function() {
                window._setters.history.add(); 
            });
            if(!this.onpopstateSet) this.listen();
        },
        add: function(){
            const browser = this.browser();
            
            if(document.referrer !== ''){
                if(browser !== 'safari' && window.history.length === 1 || browser === 'safari' && window.history.length === 2){
                    const currentURL = window.location.href,
                        previousURL = document.referrer+'#history_reload';
                    if (document.referrer.indexOf(window.location.host) === -1) {
                        window.history.replaceState({},'', currentURL);
                    } else {
                        window.history.replaceState({},'',previousURL);
                        window.history.pushState({},'',previousURL);
                        window.history.replaceState({},'',currentURL);
                    }
                }
            }
        },
        browser: function(){
            var test = function(regexp) { return regexp.test(window.navigator.userAgent);}
            switch(true){
                  case test(/edge/i): return "edge";
                  case test(/opr/i) && (!!window.opr || !!window.opera): return "opera";
                  case test(/chrome/i) && !!window.chrome: return "chrome";
                  case test(/trident/i) : return "ie";
                  case test(/firefox/i) : return "firefox";
                  case test(/safari/i): return "safari";
                  default: return "other";
            }
        },
        onpopstateSet: false,
        listen: function(){
            window.onpopstate = function(event){ 
                window._setters.history.reload();
            };
            
        },
        reload: function(){
            if(window.location.hash.indexOf('#history_reload') !== -1){
                window.location.href = window.location.hash.split('#history_reload')[0];
            }
        }
    },
    imgasbg: {
        _init: function(){
            var imgHolders = document.getElementsByClassName('img-as-bg');
            
            if(imgHolders.length > 0){
                for(var i = 0; i < imgHolders.length; i++){
                    _setters.imgasbg.apply(imgHolders[i]);
                }
            }
        }, 
        apply: function(element){
            var image = element.getElementsByTagName('img');
           
            element.style.backgroundImage = 'url('+image[0].src+')';
            element.style.backgroundSize = '100%';
            element.style.backgroundPosition = 'center';
            
            image[0].style.visibility = 'hidden';
        }
    },
    loading: {
        element: document.getElementById('full-loading'),
        on: function(){
            this.element.style.display = 'block';
        },
        off: function(){
            this.element.style.display = 'none';
        }
    },
    select: {
        _init: function(){
            if(cvtemplating.is_mobile) this.placeholder();
        },
        placeholder: function(){
            var selectors = document.querySelectorAll('[data-has-empty-value]'),
                selectit = false;
            
            for(var i=0; i < selectors.length; i++){
                selectit = false;
                
                if(!selectors[i].value){ // no option selected
                    selectit = true;
                }
                
                for(var j=0; j < selectors[i].options.length; j++){
                    if(!selectors[i].options[j].value){ // empty value
                        selectors[i].options[j].disabled = true;
                        if(selectit){ 
                            selectors[i].options[j].selected = true;
                        }
                    }
                }
            }
        }
    }
};

window._setters._init();

